import { useRelationshipLevels } from "@/hooks/queries";
import styles from "./styles.module.css";

type Props = {
  currentLevel: number | null | undefined;
  onSelect: (level: number | null) => void;
  /** Whether to render the "None" (clear) row. Defaults to true. */
  includeNone?: boolean;
};

/**
 * The shared Relationship Level picker table — rendered inside the
 * RelationshipLevelSelect popover and the Top30Checkbox level-picker dialog.
 */
export const RelationshipLevelTable = ({
  currentLevel,
  onSelect,
  includeNone = true,
}: Props) => {
  const { data: levels = [] } = useRelationshipLevels();

  return (
    <table className={styles.levelTable}>
      <thead>
        <tr>
          <th>Level</th>
          <th>Title</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        {includeNone && (
          <tr
            className={`${styles.levelRow} ${currentLevel == null ? styles.selected : ""}`}
            onClick={() => onSelect(null)}
          >
            <td colSpan={3}>
              <em>None</em>
            </td>
          </tr>
        )}
        {levels.map((level) => (
          <tr
            key={level.level}
            className={`${styles.levelRow} ${currentLevel === level.level ? styles.selected : ""}`}
            onClick={() => onSelect(level.level)}
          >
            <td className={styles.levelNum}>{level.level}</td>
            <td className={styles.levelTitle}>{level.title}</td>
            <td className={styles.levelDesc}>{level.description}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
